import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

export type ScreenType = 'small' | 'medium' | 'large' | 'extra-large';

@Injectable({
  providedIn: 'root',
})
export class BreakpointHelperService {
  readonly screenType$ = new BehaviorSubject<ScreenType>('medium');
  readonly _screenType$: Observable<ScreenType> = this.breakpointObserver.observe([
    Breakpoints.XSmall,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Large,
    Breakpoints.XLarge,
  ]).pipe(
    map((result) => {
      if (result.breakpoints[Breakpoints.XSmall]) {
        return 'small';
      }
      if (result.breakpoints[Breakpoints.Small]) {
        return 'medium';
      }
      if (result.breakpoints[Breakpoints.Medium]) {
        return 'large';
      }
      if (result.breakpoints[Breakpoints.Large] || result.breakpoints[Breakpoints.XLarge]) {
        return 'extra-large';
      }
      return 'medium';
    }),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  constructor(private readonly breakpointObserver: BreakpointObserver) {
    this._screenType$.subscribe(this.screenType$);
  }
}
